import { IValidateQuiz } from '@sdk/contracts';
import { useMutation } from '@tanstack/react-query';

import { useQuizForm } from '@/hooks';
import { sdk } from '@/services';

const QuizService = sdk.getService('QuizService');

export const useValidateQuizQuestion = () => {
  const { setQuestions } = useQuizForm();

  const { mutate: validateBulkQuestions, isPending: isValidateBulkQuestionsPending } = useMutation({
    mutationFn: (quiz: IValidateQuiz) => QuizService.validateBulkQuestions(quiz),
    onSuccess: (updatedQuiz: IValidateQuiz) => {
      const { questions } = updatedQuiz;
      setQuestions(questions);
    }
  });

  return {
    isWorking: isValidateBulkQuestionsPending,
    validateBulkQuestions
  };
};
